import { z } from 'zod';
import { optionalString, optionalInt } from './common.js';
const currentYear = new Date().getFullYear();
/** Schéma de création d'un véhicule. */
export const createVehicleSchema = z.object({
    customerId: z.string().min(1, 'Client requis'),
    licensePlate: z
        .string()
        .trim()
        .min(1, 'Immatriculation requise')
        .max(20)
        .transform((v) => v.toUpperCase()),
    vin: optionalString(30).transform((v) => v?.toUpperCase()),
    make: z.string().trim().min(1, 'Marque requise').max(60),
    model: z.string().trim().min(1, 'Modèle requis').max(60),
    year: optionalInt({ min: 1900, max: currentYear + 1 }),
    engine: optionalString(60),
    mileage: optionalInt({ min: 0, max: 2_000_000 }),
    color: optionalString(40),
    fuelType: optionalString(30),
});
/** Mise à jour : le client de rattachement n'est pas modifiable ici. */
export const updateVehicleSchema = createVehicleSchema.omit({ customerId: true }).partial();
//# sourceMappingURL=vehicle.js.map